import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  relationshipsData: [],
  allRelationshipsData: [],
  loading: false,
  error: null,
};

const relationshipsSlice = createSlice({
  name: "relationships",
  initialState,
  reducers: {
    fetchRelationshipsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchRelationshipsSuccess: (state, action) => {
      const { data = [] } = action.payload || {};
      const normalized = Array.isArray(data) ? data : [];
      state.relationshipsData = normalized;
      state.allRelationshipsData = normalized;
      state.loading = false;
    },
    searchRelationships: (state, action) => {
      const query = (action.payload || '').toLowerCase();
      state.relationshipsData = query ? state.allRelationshipsData.filter((item) =>
        [
          item.OrganizationName,
          item.Address1,
          item.Address2,
          item.City,
          item.County,
          item.Zip,
          item.State,
        ].some((field) => (field || '').toString().toLowerCase().includes(query)),
      ) : state.allRelationshipsData;
    },
    fetchRelationshipsFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchRelationshipsRequest,
  fetchRelationshipsSuccess,
  fetchRelationshipsFailure,
  searchRelationships,
} = relationshipsSlice.actions;

export default relationshipsSlice.reducer;
